import "core-js/stable";
import "regenerator-runtime/runtime";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import FontFaceObserver from "fontfaceobserver";

import App from "containers/App";
import * as FeatureFlags from "utils/featureFlags";

/* eslint-disable import/no-webpack-loader-syntax */
import "!file-loader?name=[name].[ext]!./images/favicon.ico";
/* eslint-enable import/no-webpack-loader-syntax */

import "styles/bootstrap.min.css";
import "aible/global.css";
import "aible/style.css";

import configureStore, { history } from "./configureStore";

import { getTokenExpires } from "utils/request";

import { updateIsAuthenticated, checkRefresh, storeItem, handleLogout } from "containers/Login/reducer";
import { tokenExpirationPolicy } from "containers/Login/policies";
import { updateFromMessage } from "containers/Predict/reducer";
import { updateIsGoogleMode, updateGoogleSheetsData } from "containers/App/reducer";
import { fetchDatasetWithoutDetails } from "containers/Home/reducer";

// import { connectExtensionHost, LookerExtensionSDK40 } from "@looker/extension-sdk";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

//POWERBI STUFF HERE PRAY FOR ME

import * as config from "components/PowerBI/config";

const msalInstanceProvider = new PublicClientApplication(generateMsalConfig());

// Refer https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react#configure-your-javascript-spa
function generateMsalConfig() {
  const msalConfig = {
    auth: {
      clientId: config.clientId,
      authority: config.authorityUrl,
      redirectUri: window?.location?.origin + "/"
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }
  };

  return msalConfig;
}

// Observe loading of Open Sans (to remove open sans, remove the <link> tag in
// the index.html file and this observer)
const openSansObserver = new FontFaceObserver("Open Sans", {});

// When Open Sans is loaded, add a font-family using Open Sans to the body
openSansObserver.load().then(
  () => {
    document.body.classList.add("fontLoaded");
  },
  () => {
    document.body.classList.remove("fontLoaded");
  }
);

// Create redux store with history
const initialState = {};
export const store = configureStore(initialState);
const MOUNT_NODE = document.getElementById("app");

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);

window.addEventListener("resize", () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

window.addEventListener("message", (event) => {
  if (event.data?.type === "GOOGLE") {
    console.log("gEvent");
    console.log(event.data);
    store.dispatch(updateIsGoogleMode(true));
    store.dispatch(updateGoogleSheetsData(event.data.sheet_data));
  } else if (event.data?.type === "GOOGLE_UPLOAD") {
    console.log("gupload");
    console.log(event.data);
    const datasetId = event.data?.datasetId;

    store.dispatch(fetchDatasetWithoutDetails(datasetId));
  }

  if (event.origin !== "https://iamaible-dev-ed.lightning.force.com") return;

  store.dispatch(updateFromMessage(event.data));

  console.log("Received: " + event.data);
});

/*
const CLIENT_ID = "TODO_CLIENT_ID";

const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <GoogleOAuthProvider clientId={CLIENT_ID}>
          <App />
        </GoogleOAuthProvider>
      </ConnectedRouter>
    </Provider>,
    MOUNT_NODE
  );
};
*/

const registerLooker = () => {
  return connectExtensionHost().then((extensionSDK) => {
    const coreSDK = LookerExtensionSDK40.createClient(extensionSDK);

    window.looker_SDK = extensionSDK;
    window.looker_API = coreSDK;
  });
};

const isLookerExtension = false; // FeatureFlags.isLookerEnabled();

const REFRESH_INTERVAL = 5 * 60 * 1000;

if (isLookerExtension) {
  window.addEventListener("DOMContentLoaded", async (event) => {
    //MOUNT_NODE.innerHTML = "";
    var root = document.createElement("div");
    document.body.appendChild(root);

    const lookerResp = await registerLooker();
    window.looker_aKeys = {
      aible_auth_token: undefined,
      aible_account_id: undefined,
      aible_last_folder_id: undefined,
      aible_token_expires: undefined,
      aible_tos: undefined,
      aible_user_email: undefined,
      aible_user_id: undefined,
      aible_user_name: undefined,
      aible_user_token: undefined,
      latest_acccount_id: undefined,
      latest_tenant_id: undefined
    };

    for (const aKey of Object.keys(window.looker_aKeys)) {
      const nextItem = await window.looker_SDK.localStorageGetItem(aKey);
      window.looker_aKeys[aKey] = nextItem;
      store.dispatch(storeItem(aKey, nextItem));
    }

    if (window.looker_aKeys.aible_auth_token !== undefined && window.looker_aKeys.aible_auth_token !== null) {
      if ((window.looker_aKeys.aible_token_expires - new Date().getTime()) / 1000 < 0) {
        store.dispatch(updateIsAuthenticated(false));
      } else {
        store.dispatch(updateIsAuthenticated(true));
      }
    }

    const refreshInterval = setInterval(() => store.dispatch(checkRefresh()), REFRESH_INTERVAL);

    ReactDOM.render(
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>,
      root
    );
  });
} else {
  const valid_aible_auth_token = Boolean(localStorage && localStorage.getItem("aible_auth_token"));
  const notLoginPage = Boolean(window.location.pathname !== "/login");

  // Debugging helpers, if needed
  // console.log(window.location.pathname);
  // console.log({valid_aible_auth_token, notLoginPage});

  if (valid_aible_auth_token && notLoginPage) {
    const tokenExpires = getTokenExpires();
    const checkExpirationPolicy = tokenExpirationPolicy(tokenExpires);

    if (checkExpirationPolicy.result === "DENY") {
      console.log(checkExpirationPolicy.details)
      store.dispatch(handleLogout());
    } else {
      store.dispatch(updateIsAuthenticated(true));
    }

    // check if our token(s) need to be refreshed periodically
    setInterval(() => store.dispatch(checkRefresh()), REFRESH_INTERVAL);
  }
}

document.addEventListener("visibilitychange", async () => {
  if (document.visibilityState === "visible") {
    console.log("Page resumed visibility, checking tokens...");
    // To try and capture a moment when people resume sleep or are about to use
    // the app, we can check if the tokens are valid and log them out if that
    // isn't the case.
    await store.dispatch(checkRefresh());
  }
});

const render = () => {
  if (isLookerExtension !== true) {
    ReactDOM.render(
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <MsalProvider instance={msalInstanceProvider}>
            <App />
          </MsalProvider>
        </ConnectedRouter>
      </Provider>,
      MOUNT_NODE
    );
  }
};

if (module.hot) {
  module.hot.accept(["containers/App", "app"], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render();
  });
}

if (module && module.hot && module.hot.accept) {
  module.hot.accept();
}

//ReactDOM.unmountComponentAtNode(MOUNT_NODE);

FeatureFlags.init().then(render);
